<footer class="fe-footer">
  <div class="fe-footer__company">&copy; {{ company }}</div>
</footer>
